import React from 'react';
import SetInnerHTML from '../../../../UI/SetInnerHTML/SetInnerHTML';
import SharedTippyTop, { SharedTippyTopHeight } from '../../../Shared/Header/TippyTop/TippyTop';
import './tippy-top.scss';

export class TippyTop extends SharedTippyTop {
  constructor(props) {
    super(props);
  }
  render() {
    if (!this.state.content) return null;
    return (
      <div className='perm-tippy-top desktop-perm-tippy-top' onTouchEnd={this.closeMenu}>
        <SetInnerHTML className='perm-tippy-top-contents' innerHTML={this.state.content} />
      </div>
    );
  }
}

class TippyTopHeight extends SharedTippyTopHeight {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.state.height > 0) {
      return (
        <style>
          {`
              #my_dillards_bar_wrapper{top:${this.state.height}px!important;}
              #menu_wrapper{top:${35 + this.state.height}px!important;}
          `}
        </style>
      );
    }
  }
}

export default TippyTop;
